import AddToWatchlistForm from './dumb.js';

export default AddToWatchlistForm;
